// Import utilities
const {
	isEmpty,
	isDefined
} = _uo.utility;

import { sortArrayOfObjectsAlphabetically } from '@builder-legacy/common/utilities';

/**
 * Returns the list of conditions of a specific integration
 *
 * @param {Object} options                 The options
 * @param {String} options.integrationCode The integration code
 * @param {Object} options.filters         Filters to be applied to the object. Check the filters object below.
 * @return {Object}                        The conditions
 */
const getConditionsByIntegration = ( { integrationCode, filters = {} } ) => {
	// Check if the integration code is defined
	if ( isEmpty( integrationCode ) ) {
		return {};
	}

	// Check if the integration has conditions at all
	if ( ! UncannyAutomator.integrations[ integrationCode ].conditions.hasConditions ) {
		return {};
	}

	// Default filters
	filters = Object.assign( {

		/**
		 * True if it MUST be true
		 * false if it MUST be false
		 * null to ignore the property
		 *
		 * @type {Boolean}
		 */
		deprecated: null,

		/**
		 * Custom callback
		 *
		 * @type {Callback}
		 */
		customFilter: null,

	}, filters );

	let conditions = {};

	// Iterate all conditions
	Object.entries( UncannyAutomator.integrations[ integrationCode ].conditions.available ).forEach( ( [ conditionCode, condition ] ) => {
		// Default value
		let shouldAdd = true;

		// Check custom callback
		if ( isDefined( filters.customFilter ) ) {
			shouldAdd = filters.customFilter( condition );
		}

		// Check if we should return only deprecated or non-deprecated conditions
		if ( isDefined( filters.deprecated ) ) {
			// If the "deprecated" property has been defined in the condition, compare it to the filter
			// Otherwise, asume this is NOT deprecated. "deprecated" will be defined most of the times,
			// unless they are using an old version of Automator Pro
			const isDeprecated = isDefined( condition.deprecated ) ? condition.deprecated : false;
			shouldAdd = filters.deprecated === isDeprecated;
		}

		// Add it
		if ( shouldAdd ) {
			// Add ID
			condition.id = conditionCode;

			// Add condition
			conditions[ conditionCode ] = condition;
		}
	} );

	// Convert to array and sort
	conditions = sortArrayOfObjectsAlphabetically( Object.values( conditions ), 'name' );

	return conditions;
}

export default getConditionsByIntegration;
